export default {
  init() {

  },
  finalize() {
    // The ID parameter does not persist when switching languages so this is a hacky resolution
    if ($('.wpml-ls-link').length > 0) {
      $('.wpml-ls-link').each(function() {
        const thisLang = $(this).parent().hasClass('wpml-ls-item-en') ? 'en' : 'cy';
        const switchId = $('.single-news-article').data(`pid-${thisLang}`);

        if (!switchId) {
          $(this).parent().remove();
        } else {

          let langUrl = new URL($(this).attr('href'));
          langUrl.searchParams.append('id', switchId);

          $(this).attr('href', langUrl.href);

        }
      });
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateNewsItem.js